/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `automatic` - Automatic
 * * `mandatory` - Mandatory
 * * `ondemand` - On Demand
 */
export enum DownloadTypeEnum {
    AUTOMATIC = 'automatic',
    MANDATORY = 'mandatory',
    ONDEMAND = 'ondemand',
}
